// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"index_logoContainer_1RIet","title":"index_title_1_Mjv","block":"index_block_2N7nl","inner":"index_inner_cN94M","form":"index_form_6DyGj"};